import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Fan Icon Style 03 - Toys Fan (Material Symbol)
 * Windmill/pinwheel style fan
 */
export const Style03_Windmill: React.FC<DeviceIconProps> = ({
  isOn = false,
  size = 'small',
  className = '',
  animated = true,
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-teal-500' : 'text-slate-400';
  const animationClass = isOn && animated ? 'fan-spin-medium' : '';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${animationClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      toys_fan
    </span>
  );
};

export default Style03_Windmill;
